import type { IntlShape } from 'react-intl'
import type { PurchaseInvoiceHeader } from './types'

export const purchaseInvoiceTableHeaders: PurchaseInvoiceHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tila',
				description: 'Table column header: state',
			}),
		key: 'state',
		show: true,
		sortable: true,
		type: 'status',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Numero',
				description: 'Table column header: number',
			}),
		key: 'id',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittaja',
				description: 'Table column header: supplier',
			}),
		key: 'suppCname',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskunumero',
				description: 'Table column header: Invoice number',
			}),
		key: 'invoiceNum',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: Date',
			}),
		key: 'date',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Table column header: Due date',
			}),
		key: 'dueDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Summa',
				description: 'Table column header: Total',
			}),
		key: 'total',
		show: true,
		sortable: true,
		type: 'string',
	},
]
